import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ViewModifyCancelFlow from './ViewModifyCancelFlow';

const ViewModifyCancelFlowWrapper = (props) => (
  <Router basename='/'>
    <ViewModifyCancelFlow {...props} />
  </Router>
);

export default ViewModifyCancelFlowWrapper;
